import { Routes } from "@angular/router";
import { loadTranslationResolver } from "@app/kernel/translations/resolvers/load-translations.resolver";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { TRANSLATION_PATHS } from "@app/shared/general/translation/constants/translation.constant";
import { GeoProvinceApiService } from "@app/shared-core/general/geo/services/geo-province-api.service";
import { GeoCountryApiService } from "@app/shared-core/general/geo/services/geo-country-api.service";
import { GeoCityApiService } from "@app/shared-core/general/geo/services/geo-city-api.service";
import { GeoCapApiService } from "@app/shared-core/general/geo/services/geo-cap-api.service";

export const geoDataRoutes: Routes = [
  {
    path: "geo-countries",
    loadChildren: () => import("./domains/countries/geo-countries.routes").then(m => m.geoCountriesRoutes),
    canActivate: [AuthGuard],
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.GEO_DATA.COUNTRIES, TRANSLATION_PATHS.GEO_DATA.SHARED]) },
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.GEO_COUNTRY.VIEW },
    providers: [GeoCountryApiService],
  },
  {
    path: "geo-provinces",
    loadChildren: () => import("./domains/provinces/geo-provinces.routes").then(m => m.geoProvincesRoutes),
    canActivate: [AuthGuard],
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.GEO_DATA.PROVINCES, TRANSLATION_PATHS.GEO_DATA.SHARED]) },
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.GEO_PROVINCE.VIEW },
    providers: [GeoProvinceApiService],
  },
  {
    path: "geo-cities",
    loadChildren: () => import("./domains/cities/geo-cities.routes").then(m => m.geoCitiesRoutes),
    canActivate: [AuthGuard],
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.GEO_DATA.CITIES, TRANSLATION_PATHS.GEO_DATA.SHARED]) },
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.GEO_PROVINCE.VIEW },
    providers: [GeoCityApiService],
  },
  {
    path: "geo-caps",
    loadChildren: () => import("./domains/caps/geo-caps.routes").then(m => m.geoCapsRoutes),
    canActivate: [AuthGuard],
    resolve: { translation: loadTranslationResolver([TRANSLATION_PATHS.GEO_DATA.CAPS, TRANSLATION_PATHS.GEO_DATA.SHARED]) },
    data: { authGuardOptions: COMMON_GUARD_OPTIONS.GEO_CAP.VIEW },
    providers: [GeoCapApiService],
  },
];
